import React from 'react';

/** Bell notification icon - outlined style with optional red dot and "muted" badge */
export const BellIcon = ({ hasNotification = false, animateDot = false, isMuted = false, size = 28 }) => (
  <div style={{ position: 'relative', width: size, height: size }} data-testid="allure-bell-icon" data-muted={isMuted ? '1' : '0'}>
    <style>{`@keyframes allure-bell-breathe { 0%, 100% { transform: scale(1); opacity: 0.7; } 50% { transform: scale(1.18); opacity: 1; } }`}</style>
    <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 9.33333C21 7.47681 20.2625 5.69634 18.9497 4.38359C17.637 3.07083 15.8565 2.33333 14 2.33333C12.1435 2.33333 10.363 3.07083 9.05025 4.38359C7.7375 5.69634 7 7.47681 7 9.33333C7 17.5 3.5 19.8333 3.5 19.8333H24.5C24.5 19.8333 21 17.5 21 9.33333Z"
        stroke="var(--text)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
      />
      <path
        d="M16.0184 24.5C15.7964 24.8831 15.4754 25.2024 15.0874 25.4251C14.6994 25.6478 14.258 25.7654 13.8084 25.7654C13.3588 25.7654 12.9174 25.6478 12.5294 25.4251C12.1414 25.2024 11.8204 24.8831 11.5984 24.5"
        stroke="var(--text)" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
      />
    </svg>
    {hasNotification && (
      <div
        data-testid="allure-bell-unread-dot"
        style={{
          position: 'absolute',
          top: 1,
          right: 2,
          width: 10,
          height: 10,
          borderRadius: '50%',
          backgroundColor: '#E53935',
          border: '2px solid var(--app-bg)',
          animation: animateDot ? 'allure-bell-breathe 1.6s ease-in-out infinite' : 'none',
        }}
      />
    )}
    {isMuted && (
      <div
        data-testid="allure-bell-muted-badge"
        title="Some lock-screen pushes are muted"
        aria-label="Some lock-screen pushes are muted"
        style={{
          position: 'absolute',
          bottom: -2,
          right: -2,
          width: 14,
          height: 14,
          borderRadius: '50%',
          backgroundColor: 'var(--surface)',
          border: '1.5px solid var(--text-2)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 1px 2px rgba(0,0,0,0.12)',
        }}
      >
        <svg width="9" height="9" viewBox="0 0 12 12" fill="none">
          <path d="M2 2 L10 10" stroke="var(--text-2)" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      </div>
    )}
  </div>
);

export default BellIcon;
